// extracted by mini-css-extract-plugin
export default {"wrapper":"yq-z","response":"zq-z","error":"Aq-z","disabled":"Bq-z","buttons":"Cq-z","feedbackQuestionSection":"Dq-z","yesNoWrapper":"Eq-z"};